import ProductTypesEnum from '@/models/ProductTypesEnum';

export default {
    data() {
        return {
            variants: [],
            arrivalDate: null,
            showCalendar: true,
            // upselling
            selectedVariant: null,
            // countdown
            isExpired: false
        };
    },
    props: {
        productDetails: Object
    },
    computed: {
        arrivalDates() {
            return (this.productDetails.variantsWithScheduledArrival || []).map(variant => variant.arrivalDate);
        },
        isValueVoucher() {
            return [ProductTypesEnum.VALUE_VOUCHER, ProductTypesEnum.MULTI_VOUCHER].includes(
                this.productDetails.productCategory
            );
        },
        isUpselling() {
            return (
                !this.isSoldOut &&
                !!this.variants.length &&
                !this.isValueVoucher &&
                !this.isOtherProduct &&
                this.productDetails.variantSelectionMode === 'FormView'
            );
        },
        isAuctionOffer() {
            return this.productDetails.auctionOffer;
        },
        isCheckoutActive() {
            return this.productDetails.checkoutActive;
        },
        isSoldOut() {
            return this.productDetails.soldOut;
        },
        showBiddingForm() {
            return this.isAuctionOffer && !!this.selectedVariant && !this.isExpired;
        },
        showCountdownBackButton() {
            if (this.isAuctionOffer) {
                return this.showBiddingForm; // boolean
            }
            return undefined; // must be undefined to remove button completely (to fix top offset)
        },
        isOtherProduct() {
            return (
                this.productDetails.hotelVoucherType === 'ExternalTravelVoucher' ||
                this.productDetails.hotelVoucherType === 'OtherExternalVoucher'
            );
        },
        isDirectBooking() {
            return this.productDetails.scheduledArrivalAvailable;
        },
        isDirectBookingCalendar() {
            return this.productDetails.scheduledArrivalAvailable && !this.variants.length;
        },
        isDirectBookingDateShown() {
            return !this.showCalendar && this.arrivalDate;
        },
        isAccessCodeRequired() {
            return this.$store.state.globalMeta.accessCodeRequired;
        },
        noPriceProvided() {
            return (
                !this.price ||
                (!this.price.minimumPerPersonPerNightPrice &&
                    !this.price.minimumPerPersonPrice &&
                    !this.price.minimumPrice)
            );
        },
        price() {
            return this.$getSafe(this.productDetails, 'price.regularPriceValues');
        },
        isDelayPayment() {
            return this.$store.state.globalMeta.delayPayment;
        }
    },
    methods: {
        dateSelect(date) {
            this.arrivalDate = date;
            this.showCalendar = false;
            this.variants = this.findVariantsByDate(date);
            this.selectedVariant = this.variants[0];
        },
        backToCalendar() {
            this.variants = [];
            this.showCalendar = true;
        },
        gtmTrackVariantSelection(variant) {
            this.$isDev && console.log('gtmTrackVariantSelection', variant);
            if (this.$gtm) {
                this.$gtm.pushProductSelection(this.productDetails, variant);
            }
        },
        onFlatVariantSelection(variant) {
            this.gtmTrackVariantSelection(variant);

            if (this.isAuctionOffer) {
                this.selectedVariant = variant;
            }
        },
        onUpsellVariantSelection(variant) {
            //this.gtmTrackVariantSelection(variant);

            this.selectedVariant = variant;
        },
        findVariantsByDate(date) {
            const found = this.productDetails.variantsWithScheduledArrival.find(
                variant => variant.arrivalDate === date
            );
            return found ? found.variants : null;
        },
        preselectDateFromQuery() {
            const { from } = this.$route.query;
            if (from && this.findVariantsByDate(from)) {
                this.dateSelect(from);
            }
        }
    },
    watch: {
        productDetails: {
            handler(details) {
                this.variants = details.variants || [];

                if (this.isUpselling) {
                    this.selectedVariant = this.variants[0];
                }
            },
            immediate: true
        }
    },
    created() {
        this.preselectDateFromQuery();
    }
};
